import { $, $$ } from '@utils';

function init() {
  if (!$('[data-au-float-input]')) return;

  floatInputEmptyOrFilledOnKeyup();
}

// Helper function to show clear button
function floatInputContainerAddActive(inputContainer) {
  inputContainer.classList.add('au-float-input--clear-active');
}

// Helper function to hide clear button
function floatInputContainerRemoveActive(inputContainer) {
  inputContainer.classList.remove('au-float-input--clear-active');
}

// Helper function to toggle visibility of the clear button
function floatInputToggleClearButtonVisibility(input, inputContainer) {
  if (input.value.trim() !== '') {
    floatInputContainerAddActive(inputContainer);
  } else {
    floatInputContainerRemoveActive(inputContainer);
  }
}

function floatInputEmptyOrFilledOnKeyup() {
  // Initialize the functionality for all inputs with the `data-au-float-input` attribute
  $$('[data-au-float-input]').forEach((inputContainer) => {
    const input = inputContainer.querySelector('[data-au-float-input-el]');
    const clearButton = inputContainer.querySelector('[data-au-float-input-clear]');

    if (!input || !clearButton) return; // Skip if input or button is missing

    // Show the clear button if input has text or gains focus
    input.addEventListener('input', () => floatInputToggleClearButtonVisibility(input, inputContainer));
    input.addEventListener('focus', () => floatInputToggleClearButtonVisibility(input, inputContainer));

    // Hide the clear button when input loses focus (if not focusing the button)
    input.addEventListener('blur', () => {
      setTimeout(() => {
        if (document.activeElement !== clearButton) {
          floatInputContainerRemoveActive(inputContainer);
        }
      }, 0);
    });

    // Show the clear button when the button itself is focused
    clearButton.addEventListener('focus', () => {
      if (input.value.trim() !== '') {
        floatInputContainerAddActive(inputContainer);
      }
    });

    // Hide the clear button when the button loses focus
    clearButton.addEventListener('blur', () => {
      setTimeout(() => {
        if (document.activeElement !== input) {
          floatInputContainerRemoveActive(inputContainer);
        }
      }, 0);
    });

    // Clear the input and hide the button on click
    clearButton.addEventListener('click', () => {
      input.value = '';
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.dispatchEvent(new Event('change', { bubbles: true }));
      input.focus(); // Refocus the input field
      floatInputToggleClearButtonVisibility(input, inputContainer);
    });
  });
}

export default { init };
